import { render, staticRenderFns } from "./WaveNewIcon.vue?vue&type=template&id=4777201b"
import script from "./WaveNewIcon.vue?vue&type=script&lang=js"
export * from "./WaveNewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports